<template>
	<div class="bg-white h-screen">
		<HeroSection/>
		<ContentSection/>
<!--		<CallToActionSection/>-->
<!--		<StatsSection/>-->
<!--		<TestimonialSection/>-->
		<CertificationSection/>
		<FooterSection/>
		
		<!-- Version Number Display -->
		<!-- <div class="fixed bottom-4 right-4 text-xs text-gray-400 bg-white/80 backdrop-blur-sm px-2 py-1 rounded shadow-sm">
			v{{ version }}
		</div> -->
		<div class="fixed bottom-4 right-4 text-xs text-gray-400 bg-white/80 backdrop-blur-sm px-2 py-1 rounded shadow-sm">
			v{{ version }}
		</div>
	</div>
</template>

<script>
import { Dialog, DialogPanel } from '@headlessui/vue'
import { IconMenu2, IconX } from '@tabler/icons-vue';
import ContentSection from "@/Pages/Landing/ContentSection.vue";
// import CallToActionSection from "@/Pages/Landing/CallToActionSection.vue";
// import TestimonialSection from "@/Pages/Landing/TestimonialSection.vue";
// import StatsSection from "@/Pages/Landing/StatsSection.vue";
import FooterSection from "@/Pages/Landing/FooterSection.vue";
import CertificationSection from "@/Pages/Landing/CertificationSection.vue";
import HeroSection from "@/Pages/Landing/HeroSection2.vue";

export default {
	name: "LandingView",
	components: {
		HeroSection,
		FooterSection,
		CertificationSection,
		// StatsSection,
		// TestimonialSection,
		// CallToActionSection,
		ContentSection,
		Dialog,
		DialogPanel,
		IconMenu2,
		IconX,
	},
	data() {
		return {
			mobileMenuOpen: false,
			navigation: [
        {name: 'Haldex', href: import.meta.env.VITE_HALDEX_URL, target: '_blank'},
        {name: 'Support', href: import.meta.env.VITE_CUSTOMER_SUPPORT_URL, target: '_blank'},
        {name: 'User Guide', href: import.meta.env.VITE_USER_GUIDE_URL, target: '_blank'},
			],
			version: APPLICATION_VERSION, // Dynamic version from composer.json via Vite
		}
	},
}
</script>

<style scoped>

</style>